export default {
    dependencies: ['trackingservice'],
    callable(trackingservice) {
        trackingservice.trackEventObject({
            analyticsName: 'profile.verify-user.done',
            funnelName: 'verify-user',
            funnelStep: 'receipt',
            funnelFlags: 'success',
            eventFlags: 'success',
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/trackVerififyUserSuccess.js